export default class Stats {
  constructor() {
    $('.statistics__slider').slick({
      infinite: true,
      arrows: false,
      dots: true,
    })
  }
}
